const Label = ({
    children,
   ...props
 }) => {

    return (
        <label className={props.className} htmlFor={props.for} key={props.key}>
            { children }
        </label>
     )
}

export default Label;

